export default "__VITE_PUBLIC_ASSET__9fdfb3c1__"